export default __webpack_public_path__ + "static/media/market.156cbe12.svg";